import { render, staticRenderFns } from "./SpOrderDepartmentFilter.vue?vue&type=template&id=352b5d99"
import script from "./SpOrderDepartmentFilter.vue?vue&type=script&lang=js"
export * from "./SpOrderDepartmentFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports